module.exports = __webpack_public_path__ + "fonts/b199ba1f-bec0-4e1c-8355-fd6dafae1fb9.5cb35ecb.ttf";